import React from 'react'
import { images, files } from '../../constants'
import './Hero.css'
import { motion } from 'framer-motion'

const Hero = () => {
  const imageAnimate = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      rotate: [0, 10, 0],
      transition: { type: 'spring', bounce: 0.4, duration: 1 },
    },
  }

  const textAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 1 },
    },
  }

  return (
    <motion.div
      className="mt-5 hero-container"
      initial={'offscreen'}
      whileInView={'onscreen'}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ staggerChildren: 0.8 }}
    >
      <div className="row gap-5">
        <motion.img
          src={images.hero01}
          variants={imageAnimate}
          class="img-fluid col-sm-6"
          alt="hero"
        />
        <div className="col-sm-5 row">
          <div className="col d-flex justify-content-center align-items-center">
            <div>
              <motion.h1
                className="mb-5"
                variants={textAnimate}
              >
                Experience the Edge of Freshness.
              </motion.h1>
              <motion.a
                href="/menu"
                variants={textAnimate}
              >
                View our menu →
              </motion.a>
            </div>
          </div>
        </div>
      </div>
      <div className="row gap-3 d-flex justify-content-end mt-5 hero-text">
        <motion.img
          src={images.hero02}
          variants={imageAnimate}
          className="img-fluid col-sm-3"
          alt="hero"
        />
        <div className="col-sm-3 row">
          <div className="col d-flex align-items-center">
            <div>
              <motion.p variants={textAnimate}>
                We are dedicated to bringing you an authentic and modern sushi
                experience.
              </motion.p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Hero
